/**
 * Copyright (c) samjay.dev.
 *
 * Notes:
 * This source code is the private property of samjay.dev.
 * You cannot modify, share or copy these source codes without any formal authorization,
 * otherwise samjay.dev reserves the right to pursue any legal action.
 *
 * Developer: Sam Tsang (info@samjay.dev)
 */

import React, { useEffect } from 'react';
import { InView } from 'react-intersection-observer';
import {
  Link
} from "react-router-dom";
import { getSvgIcon } from 'resources';
import AppStyle from 'scss/main/App.module.scss';

const NotFound: React.FC<{}> = () => {

  return (
    <div className={AppStyle["notFound"]}>
      <div>
        <InView triggerOnce>
          {({ inView, ref, entry }) => (
            <div className={`${inView && AppStyle['descAnimF']}`} style={{ opacity: !inView ? '0.0' : '1.0' }} ref={ref}>
              <div dangerouslySetInnerHTML={{ __html: `${getSvgIcon({ name: "404" })} ${getSvgIcon({ name: "damage" })}` }} />
            </div>
          )}
        </InView>
        <div>
          <div>
            <div className={AppStyle["buttonLine"]}><Link to="/">Go to Homepage</Link></div>
            <div dangerouslySetInnerHTML={{ __html: `${getSvgIcon({ name: "right" })}` }} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default NotFound